import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "./primitives";
import { radrootConfig } from "@/config/radrootConfig";

function CopyAddr({ value }) {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setDone(true);
      toast.success("Address copied");
      setTimeout(() => setDone(false), 1600);
    } catch {
      toast.error("Copy failed — select the address manually");
    }
  };
  return (
    <button type="button" className="copy-btn" data-testid="footer-copy-delegation-btn" onClick={copy} aria-label="Copy delegation address">
      {done ? <Check size={15} /> : <Copy size={15} />}
    </button>
  );
}

export default function Footer() {
  return (
    <footer className="footer" data-testid="footer-section">
      <span className="footer-ghost" aria-hidden="true">
        √
      </span>
      <div className="wrap">
        <Reveal>
          <div className="footer-brand">
            <img src="/logo-wordmark.png" alt="Radroot" />
          </div>
          <div className="footer-disc">
            <p data-testid="footer-disclaimer-affiliation">
              Radroot is an independent project and is not affiliated with or endorsed by the Flare Foundation.
            </p>
            <p data-testid="footer-disclaimer-risk">
              Participation involves risk. Rewards are variable and are not guaranteed.
            </p>
          </div>
          {radrootConfig.delegationAddress && (
            <div className="footer-addr" data-testid="footer-delegation-address">
              <div className="footer-addr-text">
                <span className="footer-addr-label">Delegation address — Flare mainnet</span>
                <code>{radrootConfig.delegationAddress}</code>
              </div>
              <CopyAddr value={radrootConfig.delegationAddress} />
            </div>
          )}
          <div className="footer-base">
            <span>© {new Date().getFullYear()} Radroot</span>
            <span>Independent Flare infrastructure</span>
          </div>
        </Reveal>
      </div>
    </footer>
  );
}
